import React, { useState, useEffect } from "react";
import Baseurl from "../../../Baseurl";
import { Table, Col, Card, Spinner, Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function ViewAppliedCampaign() {
  const history = useHistory();
 
  const [restaurantDetails, setRestaurantDetails] = useState("");
  const [campaignDetails, setCampaignDetails] = useState(
    history.location.state.data.CampaignId
  );
  const [restaurant, setRestaurant] = useState("");
  const [reason, setReason] = useState("");
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [show1, setShow1] = useState(false);
  const [rejectStatus, setRejectStatus] = useState(false);
  const [viewimage, setViewImage] = useState();
  const handleClose1 = () => {
    setShow1(false);
  };
  function getData() {
    let restoArr = [];
    setRestaurant(history.location.state.data.RestaurantId);
    restoArr.push(
      {
        name: "Restaurant Name",
        val: history.location.state.data.RestaurantId.RName,
      },
      {
        name: "Description",
        val: history.location.state.data.RestaurantId.RDescription,
      },
      {
        name: "Cuisines",
        val: history.location.state.data.RestaurantId.RCuisines,
      },
      {
        name: "Outlet Type",
        val: history.location.state.data.RestaurantId.ROutletType,
      },

      {
        name: "Type",
        val: history.location.state.data.RestaurantId.RPureVeg
          ? "Veg"
          : "Non-Veg",
      },
      {
        name: "Address",
        val: history.location.state.data.RestaurantId.RFullAddress,
      },
      {
        name: "Land Mark",
        val: history.location.state.data.RestaurantId.RLandmark,
      },
      {
        name: "Pincode",
        val: history.location.state.data.RestaurantId.RPincode,
      },
      {
        name: "Lattitude",
        val: history.location.state.data.RestaurantId.RLatitude,
      },
      {
        name: "Longittude",
        val: history.location.state.data.RestaurantId.RLongitude,
      },
      {
        name: "Approx Price For 2 Persons",
        val: history.location.state.data.RestaurantId.RApproxPriceForTwo,
      },
      {
        name: "Start Time",
        val: history.location.state.data.RestaurantId.RStartTime,
      },
      {
        name: "End Time",
        val: history.location.state.data.RestaurantId.REndTime,
      },
      {
        name: "Fssail Code",
        val: history.location.state.data.RestaurantId.RFssaiLicCode,
      },
      {
        name: "Fssail Expiry Date",
        val: history.location.state.data.RestaurantId.RFssaiLicExpiryDate,
      },
      {
        name: "Fssail Expiry Date",
        val: history.location.state.data.RestaurantId.RFssaiLicExpiryDate,
      }
    );
    console.log("ffkfkfkfkkfkfkf", restoArr);
    setRestaurantDetails(restoArr);
  }
  useEffect(() => {
    getData();
  }, []);
  function acceptCampaign() {
    setSpinnerAccept(true);
    const params = {
        fId:history.location.state.data.CampaignId._id,
        rId:history.location.state.data.RestaurantId._id
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/approve-restaurant-for-food-campaign/${history.location.state.data._id}`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/Applied-Campaign");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
  }
  function rejectRestaurant() {
    const params = {
        reason:reason,
        rId:history.location.state.data.RestaurantId._id
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-admin/reject-restaurant-for-food-campaign/${history.location.state.data._id}`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Rejected", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.push("/Applied-Campaign");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  return (
    <div>
      <Col lg={12}>
        <Modal size="lg" show={show1} onHide={handleClose1}>
          <Modal.Body>
            {rejectStatus ? (
              <div className="row">
                <div className="col-sm-2 mt-2">
                  <label>Reason</label>
                </div>
                <div className="col-sm-8 ">
                  <textarea
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter reason"
                  />
                </div>
              </div>
            ) : (
              <div>
                <img
                  alt=""
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  className="playerProfilePic_home_tile"
                  src={viewimage}
                />
              </div>
            )}
          </Modal.Body>
          {rejectStatus && (
            <Modal.Footer>
              <button
                onClick={() => {
                  rejectRestaurant();
                }}
                className="btn btn-danger"
              >
                Reject
              </button>
            </Modal.Footer>
          )}
        </Modal>
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <div></div>
            <button
              className="btn btn-primary "
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          </Card.Header>
          <Card.Body>
            <Table className="text-white">
              <tr>
                <td>Campaign Name</td>
                <td>{campaignDetails.Title}</td>
              </tr>
              <tr>
                <td>Campaign City</td>
                <td>{campaignDetails.City&&campaignDetails.City.map((val)=>{
                    return(
                        <div>{val}</div>
                    )
                })}</td>
              </tr>
              <tr>
              <td>Start Time</td>
                <td>{campaignDetails.StartTime.Hour}:{campaignDetails.StartTime.Minute}</td>
              </tr>
              <tr>
              <td>End Time</td>
                <td>{campaignDetails.EndTime.Hour}:{campaignDetails.EndTime.Minute}</td>
              </tr>
              <tr>
                <td>Offer</td>
                <td>{campaignDetails.Offer?"Available":"Not-Available"}</td>
              </tr>
              <tr>
                <td>Campaign Image</td>
                <td> <img
                        alt=""
                        style={{
                        
                          width: 150,
                          height: 150,
                        }}
                        src={campaignDetails.Image}
                      /></td>
              </tr>
              
              {restaurantDetails &&
                restaurantDetails.map((val) => {
                  return (
                    <tr>
                      <td>{val.name}</td>
                      <td>{val.val}</td>
                    </tr>
                  );
                })}
            </Table>
            <div className="basic-form">
              <div className="row mt-4">
                <div className="col-sm-3">
                  <label>Fassail Image</label>
                </div>
                <div classname="col-sm-4">
                  <div className="register_profile_image  ml-5  ">
                    {/* <input
                        required
                        id="profilePic"
                        type="file"
                        onChange={(e) => {
                          onChangePicture(e, "fssail");
                        }}
                      /> */}
                  </div>
                  {restaurant.RFssaiLicImage && (
                    <div
                      onClick={() => {
                        viewImage(restaurant.RFssaiLicImage);
                      }}
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic"
                    >
                      <img
                        alt=""
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={restaurant.RFssaiLicImage}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-sm-3">
                  <label>Restaurant Image</label>
                </div>
                <div classname="col-sm-2">
                  {restaurant.RImage && (
                    <div
                      onClick={() => {
                        viewImage(restaurant.RImage);
                      }}
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic"
                    >
                      <img
                        alt=""
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={restaurant.RImage}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-sm-3">
                  <label>Menu Images</label>
                </div>
                <div classname="col-sm-4">
                  <div className="register_profile_image  ml-3"></div>
                  <div className="row">
                    {restaurant.RMenuImage &&
                      restaurant.RMenuImage.map((val) => {
                        return (
                          <div
                            onClick={() => {
                              viewImage(val);
                            }}
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="previewProfilePic col-sm-4"
                          >
                            <img
                              alt=""
                              className="playerProfilePic_home_tile"
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={val}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
          <Card.Footer>
              {spinnerAccept ? (
                <div className="ml-auto mr-2 float-right">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <button
                  className="btn btn-primary float-right"
                  onClick={() => {
                    acceptCampaign();
                  }}
                >
                  Accept
                </button>
              )}

              <button
                onClick={() => {
                  setRejectStatus(true);
                  setShow1(true);
                }}
                className="btn btn-danger text-center "
              >
                Reject
              </button>
            </Card.Footer>
        </Card>
      </Col>
    </div>
  );
}
